import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const InsightsPageBannerSection = ({ className, tag }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<h1>{tag ? `${tag.label}` : <DynamicText path={`page.insights.banner.title.${locale}`} tag="span" />}</h1>}
      image={{ path: "page.insights.banner.image", src: "/assets/banners/default.webp" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml
            path={tag ? `page.insights.${tag.url_slug}.banner.text.${locale}` : `page.insights.banner.text.${locale}`}
          />
        </Col>
      </Row>
    </Banner>
  );
};
